import script from "./percentage.vue?vue&type=script&lang=js&setup=true"
export * from "./percentage.vue?vue&type=script&lang=js&setup=true"

import "./percentage.vue?vue&type=style&index=0&id=bb18d01e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb18d01e"]])

export default __exports__